<template>
  <dara-single-content-layout container-size="lg">
    <template #content>
      <div class="d--flex justify-content--space-between align-items--center">
        <dara-header>{{ $t('departments') }}</dara-header>
        <dara-button v-if="user.permission > 1" @click="onCreateDepartment">
          {{ $t('add-department') }}
        </dara-button>
      </div>
      <table v-if="departmentList && departmentList.length > 0" class="table">
        <tbody>
          <tr v-for="department in departmentList" :key="department.id">
            <td class="py-3 px-2">
              <dara-header size="sm">
                <dara-department-link :id="department.id" :slug="department.slug">
                  {{ department.name }}
                </dara-department-link>
              </dara-header>
              <dara-p class="text-muted">
                {{ department.description }}
              </dara-p>
            </td>
            <td class="align-middle text-end">
              <el-dropdown v-if="canEdit(department)" trigger="click">
                <dara-icon
                  icon="three-dots-vertical"
                  class="cursor--pointer mx--md" />
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <dara-department-link
                      :id="department.id"
                      action="edit">
                      <dara-icon size="sm" icon="pencil" />
                      {{ $t('edit') }}
                    </dara-department-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <a @click="setDeleteDepartment(department)">
                      <dara-icon size="sm" icon="trash" />
                      {{ $t('delete') }}
                    </a>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <dara-modal-delete-department
                v-if="showModal(department)"
                :department="department"
                @close="setDeleteDepartment(null)"
                @confirm="onDeleteDepartment(department)">
              </dara-modal-delete-department>
            </td>
          </tr>
        </tbody>
      </table>
      <dara-p v-else color="danger" class="my--lg">( {{ $t('your-company-has-no-departments') }} )</dara-p>
      <dara-pagination
        :page.sync="pagination.page"
        :total="pagination.total"
        :page-size="pagination.limit"
        @current-change="fetch" />
      <dara-modal-new-department
        v-if="showNewDepartmentModal()"
        ref="departmentModal"
        @close="closeModal()">
      </dara-modal-new-department>
    </template>
  </dara-single-content-layout>
</template>

<script>
import { fetchDepartments, removeDepartment } from '@/modules/department/department.service';
import { getters } from '@/modules/user/user.store';
import { USERS_ROLES } from '@/modules/user/user.constants';

import DaraDepartmentLink from '@/modules/department/components/DepartmentLink.vue';
import DaraSingleContentLayout from '@/layouts/SingleContentLayout.vue';

export default {
  name: 'DaraMySpaceDepartments',
  components: {
    DaraDepartmentLink,
    DaraSingleContentLayout,
  },
  data() {
    return {
      user: getters.getUser(),
      departmentList: [],
      departmentDelete: null,
      newDepartment: false,
      pagination: {
        page: 1,
        limit: 5,
      },
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    canEdit(department) {
      return (this.user.permission > USERS_ROLES.WRITER || (department.user_id === this.user.id && this.user.permission > USERS_ROLES.READER));
    },
    fetch() {
      this.departmentList = [];
      fetchDepartments(this.pagination)
        .then(data => {
          this.departmentList = data.data;
          Object.assign(this.pagination, data.pagination);
        })
        .catch(() => {
          this.departmentList = [];
        });
    },
    setDeleteDepartment(department) {
      this.departmentDelete = department;
    },
    showModal(department) {
      return this.departmentDelete && this.departmentDelete.id === department.id;
    },
    onDeleteDepartment(department) {
      removeDepartment(department).then(() => this.$router.go(0));
    },
    onCreateDepartment() {
      this.newDepartment = true;
    },
    showNewDepartmentModal() {
      return this.newDepartment;
    },
    closeModal() {
      this.$router.go(0);
      this.newDepartment = false;
    },
  },
};
</script>
